import { useMutation } from '@tanstack/react-query';
import { updateTheme, createSiteFromTemplate, setupModalystProducts } from './endpoints';
import { useMsId, useSetMsId, useSetMetasiteError } from '../../../store/appStore';
import { templateSelectionKeys } from './keys';

export function useUpdateTheme() {
  const metaSiteId = useMsId();

  return useMutation({
    mutationKey: templateSelectionKeys.mutations.updateTheme(),
    mutationFn: (themeKey?: string) => updateTheme(metaSiteId, themeKey),
    onError: (error) => {
      console.error('Failed to update theme:', error);
    },
  });
}

export function useCreateSiteFromTemplate() {
  const setMsId = useSetMsId();
  const setMetasiteError = useSetMetasiteError();

  return useMutation({
    mutationKey: templateSelectionKeys.mutations.createSite(),
    mutationFn: (category: string) => createSiteFromTemplate(category),
    onSuccess: (metaSiteId) => {
      setMsId(metaSiteId);
    },
    onError: (error) => {
      console.error('Failed to create site:', error);
      setMetasiteError(true);
    },
  });
}

export function useSetupModalystProducts() {
  return useMutation({
    mutationKey: templateSelectionKeys.mutations.setupProducts(),
    mutationFn: ({ metaSiteId, productList }: { metaSiteId: string; productList: string[] }) =>
      setupModalystProducts(metaSiteId, productList),
    onError: (error) => {
      console.error('Failed to setup products:', error);
    },
  });
}
